import { renderRoute } from './mapbox';

const mapToggle = document.querySelector('#map-toggle');
const mapDialog = document.querySelector('#map-dialog');
const mapClose = mapDialog?.querySelector('#map-close');

let dialogMap = null;

if (mapToggle && mapDialog) {
    mapToggle.addEventListener('click', () => {
        mapDialog.showModal();
        document.documentElement.classList.add('no-scroll');

        if (dialogMap) {
            dialogMap.resize();
        } else {
            const canvas = mapDialog.querySelector('.map-canvas');
            dialogMap = renderRoute(canvas);
        }
    });
    
    mapClose?.addEventListener('click', () => {
        mapDialog.close();
    });

    mapDialog.addEventListener('close', () => {
        document.documentElement.classList.remove('no-scroll');
    });
}